import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-element-select',
  templateUrl: './element-select.component.html',
  styleUrls: ['./element-select.component.scss']
})
export class ElementSelectComponent implements OnInit {

  constructor(private modalService: BsModalService) { }

  ngOnInit(): void {

  }

  selectedElement;

  closeModal() {
    this.modalService.hide();
  }

  elements = [
    {
      component: 'my-tidy-card',
      name: 'Card',
      img: '/assets/images/custom/card_placeholder.png'
    },
    {
      component: 'my-tidy-image',
      name: 'Image',
      img: '/assets/images/custom/placeholder.png'
    }
  ]

  selectElement(element) {
    this.selectedElement = element.component;
    this.closeModal();
  }

}
